import { render, staticRenderFns } from "./CarouselNovidades.vue?vue&type=template&id=5be049ec&scoped=true&"
import script from "./CarouselNovidades.vue?vue&type=script&lang=js&"
export * from "./CarouselNovidades.vue?vue&type=script&lang=js&"
import style0 from "./CarouselNovidades.vue?vue&type=style&index=0&id=5be049ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be049ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VIcon,VImg,VRow})
